export default "__VITE_ASSET__pSXPsA2e__"